import { Get, Post } from "Api";
import { apiConstant } from "../constants";

//********************** =-=-=-=-=-=-=-=-= Sample Api -=-=-=-=-=-=-=-=-=-=- **********************//

/**
 * Sample API
 */
export const fetchBaseApiDetails = async (
  method: string,
  payload?: any
): Promise<string> =>
  method === "GET"
    ? Get<string>(apiConstant.URL.MOCK, apiConstant.PATH.BASE_API)
    : Post<string>(apiConstant.URL.MOCK, apiConstant.PATH.BASE_API, payload);

/**
 * Register API
 */
export const registerClientApiDetails = async (
  payload?: any
): Promise<string> =>
  Post<string>(apiConstant.URL.CLIENT, apiConstant.PATH.CLIENT.REGISTER, {
    ...payload,
    mobile: 1234567890,
    website: payload?.email?.split("@")[1],
    company_name: payload?.email?.split("@")[1]?.split(".")[0],
  });

/**
 * Register Tech Team API
 */
export const registerTechTeamApiDetails = async (
  payload?: any
): Promise<string> =>
  Post<string>(
    apiConstant.URL.WEBSITE,
    apiConstant.PATH.CLIENT.TECH_TEAM,
    payload
  );

//********************** =-=-=-=-=-=-=-=-= Dashboard Api -=-=-=-=-=-=-=-=-=-=- **********************//

/**
 * Signup Login API
 */
export const signupLoginApiDetails = async (payload?: any): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.LOGIN.INITIATE,
    payload
  );

/**
 * Validate Token API
 */
export const validateTokenApiDetails = async (payload?: any): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.LOGIN.VALIDATE,
    payload
  );

/**
 * Get User Details API
 */
export const getUserDetailsApiDetails = async (
  payload?: any
): Promise<string> =>
  Get<string>(apiConstant.URL.BASE_API, apiConstant.PATH.USER.DETAILS, payload);

/**
 * Update User Details API
 */
export const updateUserApiDetails = async (payload?: any): Promise<string> =>
  Post<string>(apiConstant.URL.BASE_API, apiConstant.PATH.USER.UPDATE, payload);

/**
 * All Applications API
 */
export const allApplicationsApiDetails = async (
  payload?: any
): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.APPLICATION.LIST,
    payload
  );

/**
 * Create Application API
 */
export const createApplicationApiDetails = async (
  payload?: any
): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.APPLICATION.CREATE,
    payload
  );

/**
 * Update Application API
 */
export const updateApplicationApiDetails = async (
  payload?: any
): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.APPLICATION.UPDATE,
    payload
  );

/**
 * Application Details API
 */
export const applicationDetailsApiDetails = async (
  payload?: any
): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.APPLICATION.DETAILS,
    payload
  );

/**
 * Analytics Count Details API
 */
export const countDetailsApiDetails = async (payload?: any): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.ANALYTICS.DETAILS,
    payload
  );

/**
 * Analytics Graph Details API
 */
export const graphDetailsApiDetails = async (payload?: any): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.ANALYTICS.GRAPH,
    payload
  );

/**
 * Get Team Details of Organisation API
 */
export const getTeamDetailsApiDetails = async (
  payload?: any
): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.ORGANISATION.GET_TEAM_DETAILS,
    payload
  );

/**
 * Update Details of Organisation API
 */
export const updateOrganisationApiDetails = async (
  payload?: any
): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.ORGANISATION.UPDATE,
    payload
  );

/**
 * Add User from Organisation API
 */
export const addUserApiDetails = async (payload?: any): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.ORGANISATION.ADD_USER,
    payload
  );

/**
 * Remove User from Organisation API
 */
export const removeUserApiDetails = async (payload?: any): Promise<string> =>
  Post<string>(
    apiConstant.URL.BASE_API,
    apiConstant.PATH.ORGANISATION.REMOVE_USER,
    payload
  );
